import React, { useState } from 'react';
import '../styles/InviteFriend.css';

function InviteFriend({ onBack }) {
  const [copySuccess, setCopySuccess] = useState('');
  const [copyError, setCopyError] = useState('');
  const [emailError, setEmailError] = useState('');

  // App link - you can customize this URL based on your app's actual URL
  const appLink = window.location.origin || 'https://www.ucmaapp.com';
  const shareMessage = `Check out UcmaApp! Join me on this amazing messaging platform: ${appLink}`;

  const handleCopyLink = async () => {
    try {
      // Clear previous messages0
      setCopyError('');
      setCopySuccess('');

      if (navigator.clipboard && window.isSecureContext) {
        // Use modern clipboard API if available
        await navigator.clipboard.writeText(appLink);
        setCopySuccess('Link copied to clipboard!');
      } else {
        // Fallback for older browsers or non-HTTPS
        const textArea = document.createElement('textarea');
        textArea.value = appLink;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        
        const successful = document.execCommand('copy');
        document.body.removeChild(textArea);
        
        if (successful) {
          setCopySuccess('Link copied to clipboard!');
        } else {
          throw new Error('Copy command failed');
        }
      }

      // Clear success message after 3 seconds
      setTimeout(() => setCopySuccess(''), 3000);
    } catch (error) {
      console.error('Failed to copy link:', error);
      setCopyError('Failed to copy link. Please try again.');
      setTimeout(() => setCopyError(''), 3000);
    }
  };

  const handleEmailShare = () => {
    try {
      setEmailError('');
      
      const subject = encodeURIComponent('Join me on UcmaApp!');
      const body = encodeURIComponent(shareMessage);
      const mailtoUrl = `mailto:?subject=${subject}&body=${body}`;
      
      // Open email client
      window.location.href = mailtoUrl;
    } catch (error) {
      console.error('Failed to open email client:', error);
      setEmailError('Failed to open email client. Please try again.');
      setTimeout(() => setEmailError(''), 3000);
    }
  };

  return (
    <div className="invite-friend-container">
      <div className="invite-friend-header">
        <button className="back-button" onClick={onBack}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M19 12H5"/>
            <path d="M12 19l-7-7 7-7"/>
          </svg>
        </button>
        <h2>Invite a friend</h2>
      </div>

      <div className="invite-friend-content">
        <div className="invite-illustration">
          <svg width="120" height="120" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <path d="M16 21v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2"/>
            <circle cx="9" cy="7" r="4"/>
            <path d="M22 21v-2a4 4 0 00-3-3.87"/>
            <path d="M16 3.13a4 4 0 010 7.75"/>
          </svg>
        </div>

        <div className="invite-message">
          <h3>Share UcmaApp with friends</h3>
          <p>Invite your friends to join you on UcmaApp and start messaging!</p>
        </div>

        <div className="app-link-section">
          <h4>App Link</h4>
          <div className="link-container">
            <input 
              type="text" 
              value={appLink} 
              readOnly 
              className="app-link-input"
            />
            <button 
              className="copy-link-btn"
              onClick={handleCopyLink}
              disabled={copySuccess !== ''}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="9" y="9" width="13" height="13" rx="2" ry="2"/>
                <path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/>
              </svg>
              {copySuccess ? 'Copied!' : 'Copy'}
            </button>
          </div>
          
          {/* Success/Error messages for copy */}
          {copySuccess && (
            <div className="success-message">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M22 11.08V12a10 10 0 11-5.93-9.14"/>
                <polyline points="22,4 12,14.01 9,11.01"/>
              </svg>
              {copySuccess}
            </div>
          )}
          
          {copyError && (
            <div className="error-message">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10"/>
                <line x1="15" y1="9" x2="9" y2="15"/>
                <line x1="9" y1="9" x2="15" y2="15"/>
              </svg>
              {copyError}
            </div>
          )}
        </div>

        <div className="share-options">
          <h4>Share via</h4>
          <button 
            className="share-option-btn email-btn"
            onClick={handleEmailShare}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
              <polyline points="22,6 12,13 2,6"/>
            </svg>
            <span>Email</span>
          </button>
          
          {/* Error message for email */}
          {emailError && (
            <div className="error-message">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10"/>
                <line x1="15" y1="9" x2="9" y2="15"/>
                <line x1="9" y1="9" x2="15" y2="15"/>
              </svg>
              {emailError}
            </div>
          )}
        </div>

        <div className="invite-tip">
          <div className="tip-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10"/>
              <path d="M12 16v-4"/>
              <path d="M12 8h.01"/>
            </svg>
          </div>
          <p>Your friends will be able to download and join UcmaApp using this link!</p>
        </div>
      </div>
    </div>
  );
}

export default InviteFriend;